export enum Split {
  SELF_SERVICE_OAUTH = 'self_service_oauth',
}
